import { css } from '@compiled/react';
import { FormattedMessage } from 'react-intl';

import { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';

import { LoggedInUserDropdownProps } from '@/components/global-nav/user-profile-new/src/components/loggedin-user-view';
import { messages } from '@/components/global-nav/user-profile-new/src/messages';
import { wacToken } from '@/libraries/design/foundations';
import { useTheme } from '@/libraries/design/utils/dark-theme-provider';

const darkMenuCss = css({
	'--ds-text': wacToken('color.neutral.light0'),
	'--ds-text-disabled': wacToken('color.neutral.light0'),
	'--ds-background-neutral-subtle-hovered': wacToken('color.neutral.dark200'),
	'--ds-background-neutral-subtle-pressed': wacToken('color.neutral.dark300'),
});

const emailStyle = css({
	color: wacToken('color.primary.black'),
	fontWeight: '700',
	marginBlockStart: '8px',
	marginBlockEnd: '8px',
});

const userInfoStyle = css({
	paddingBlockStart: '16px',
	paddingBlockEnd: '16px',
});

const MobileLoggedInUseDropdown = ({
	userInfo,
	onLogOutClick,
	onManageLicensesClick,
	onManageProfileClick,
	onSwitchAccountClick,
}: LoggedInUserDropdownProps) => {
	const { isDarkTheme } = useTheme();
	return (
		<div
			className="mobile-logged-in-user-container"
			css={isDarkTheme && darkMenuCss}
			data-testid="global-nav-mobile-user-profile-container-user-loggedin"
		>
			<DropdownItemGroup>
				<DropdownItem isDisabled={true}>
					<div className="global-nav-userinfo" css={userInfoStyle}>
						<div className="global-nav-userinfo-email" css={emailStyle}>
							{userInfo.email}
						</div>
					</div>
				</DropdownItem>
				<DropdownItem onClick={onSwitchAccountClick}>
					<FormattedMessage {...messages.switchAccount} />
				</DropdownItem>
				<DropdownItem onClick={onManageProfileClick}>
					<FormattedMessage {...messages.profile} />
				</DropdownItem>
				<DropdownItem onClick={onManageLicensesClick}>
					<FormattedMessage {...messages.licenses} />
				</DropdownItem>
				<DropdownItem onClick={onLogOutClick}>
					<FormattedMessage {...messages.logOut} />
				</DropdownItem>
			</DropdownItemGroup>
		</div>
	);
};

export default MobileLoggedInUseDropdown;
